import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { InfoSucursales } from "./components/InfoSucursales.jsx";
import { OficinasBu } from "./components/OficinasBu.jsx";
import { OficinasCrediOro } from "./components/OficinasCrediOro.jsx";
import { OficinasEfecty } from "./components/OficinasEfecty.jsx";
import React from "react";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<InfoSucursales />} />
        <Route path="/efecty" element={<OficinasEfecty />} />
        <Route path="/oficinas-bu" element={<OficinasBu />} />
        <Route path="/credi-oro" element={<OficinasCrediOro />} />
        <Route path="/*" element={<InfoSucursales />} />
      </Routes>
    </Router>
  );
}

export default App;
